module.exports = __webpack_public_path__ + "img/result-oman-04.5bb563b4.svg";